import { render, staticRenderFns } from "./SupplierAccountInfo.vue?vue&type=template&id=c15f2c16&scoped=true"
import script from "./SupplierAccountInfo.vue?vue&type=script&lang=js"
export * from "./SupplierAccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15f2c16",
  null
  
)

component.options.__file = "SupplierAccountInfo.vue"
export default component.exports